/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description toHoodUrl
 */

import { hyphenate } from '@zcode/utils'
import { routesConstants } from '@zcode/zumper-routes'

interface Params {
  city?: string | null
  state?: string | null
  cityState?: string | null
  basePath?: `${'apartments' | 'condos' | 'houses' | 'rooms'}-for-rent` | 'rentals'
  hood: string
}

/**
 * create absolute hood url
 * will produce: /:basePath/:city-:state/:hood or /:basePath/:cityState/:hood
 * e.g. /apartments-for-rent/providence-ri/federal-hill
 *
 */

export const toHoodUrl = ({
  city,
  state,
  cityState,
  hood,
  basePath = routesConstants.APTS_BASE_URL,
}: Params) => {
  if (cityState) {
    return `/${basePath}/${cityState}/${hyphenate(hood)}` as const
  }
  if (city && state) {
    return `/${basePath}/${hyphenate(city, state)}/${hyphenate(hood)}` as const
  }
  return null
}
